import { Box, ButtonBase, Divider, Skeleton, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import ClientDashboardLayout from "../../../../components/clientDashboard/ClientDashboardLayout";
import PasswordSettings from "./sections/passwordSettings";
import UserDetails from "./sections/userDetails";

const TabButton = ({ active, label, onClick }) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        flex: "1 1 0",
        minWidth: 0,
        borderRadius: "8px",
        py: "8px",
        px: { xs: 1.5, sm: 2, md: 6 },
        bgcolor: active ? "#FFFFFF" : "transparent",
        boxShadow: active ? "0px 1px 2px 0px rgba(0,0,0,0.05)" : "none",
        transition: "background-color 0.15s ease, box-shadow 0.15s ease",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Rethink Sans', Helvetica, sans-serif",
          fontSize: "14px",
          fontWeight: active ? 600 : 500,
          lineHeight: "20px",
          color: active ? "rgba(0,0,0,0.87)" : "rgba(0,0,0,0.6)",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textTransform: "none",
        }}
      >
        {label}
      </Typography>
    </ButtonBase>
  );
};

export default function UserSettings({ initialTab = "my-details" } = {}) {
  const tabs = useMemo(
    () => [
      { key: "my-details", label: "My Details" },
      { key: "password-settings", label: "Password Settings" },
    ],
    []
  );
  const [activeTab, setActiveTab] = useState(initialTab);
  const [contentLoading, setContentLoading] = useState(true);

  return (
    <ClientDashboardLayout contentAlign="center" contentMaxWidth="100%">
      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Box>
          {contentLoading ? (
            <Skeleton variant="text" width={160} height={36} />
          ) : (
            <Typography
              sx={{
                fontFamily: "Rethink Sans",
                fontWeight: 600,
                fontSize: "24px",
                lineHeight: "133%",
                color: "rgba(0,0,0,0.87)",
                mb: "4px",
              }}
            >
              My Profile
            </Typography>
          )}
        </Box>

        <Divider sx={{ borderColor: "rgba(0,0,0,0.08)" }} />

        {contentLoading ? (
          <Skeleton variant="rounded" width="100%" height={44} sx={{ borderRadius: "8px" }} />
        ) : (
          <Box
            sx={{
              backgroundColor: "#F4F4F6",
              borderRadius: "8px",
              p: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {tabs.map((t) => (
              <TabButton
                key={t.key}
                label={t.label}
                active={activeTab === t.key}
                onClick={() => setActiveTab(t.key)}
              />
            ))}
          </Box>
        )}

        {activeTab === "my-details" ? (
          <UserDetails onLoadingChange={setContentLoading} />
        ) : (
          <PasswordSettings onLoadingChange={setContentLoading} />
        )}
      </Box>
    </ClientDashboardLayout>
  );
}
